module.exports = __webpack_public_path__ + "img/facebook.105adc4d.svg";